import _MenuItem from "@material-ui/core/esm/MenuItem";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { Color } from 'swag-client-common/components/ui/color';
import Select from '../styled-select/styled-select';
import { ColorLabelWithTooltip } from '../color-label-with-tooltip';
import classes from './giveaway-product-color-select.scss';
export class GiveawayProductColorSelectComponent extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleClick", colorVariant => e => {
      const {
        isReserve,
        shouldSkipColorClick
      } = this.props;
      if (shouldSkipColorClick) {
        return;
      }
      if (colorVariant.availableQuantity > 0 || !isReserve) {
        const {
          showSelection,
          onChange
        } = this.props;
        if (showSelection) {
          e.stopPropagation();
        }
        onChange(colorVariant.colorValue || e.target.value);
      }
    });
  }
  render() {
    var _colors$, _colors$2;
    const {
      colors,
      primaryColor,
      selectedColors,
      selectable,
      showSelection,
      isReserve,
      isOneProduct
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.colorsBlock, {
        [classes.inlineColorsBlock]: selectable
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.text, {
        [classes.inlineText]: selectable
      })
    }, colors.length > 1 ? 'What color would you like?' : 'Color:'), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.colorOptions, {
        [classes.hideForMobile]: isOneProduct
      })
    }, colors.map(color => {
      const {
        colorName,
        colorValue,
        isAvailable
      } = color;
      return /*#__PURE__*/React.createElement(ColorLabelWithTooltip, {
        hideTooltip: true,
        key: colorValue,
        name: colorName,
        value: colorValue,
        colorLabelClassname: classnames(classes.label, {
          [classes.disabled]: !isAvailable
        }),
        style: color.isSelected && showSelection ? {
          borderColor: primaryColor
        } : {},
        onClick: this.handleClick(color)
      });
    })), isOneProduct && /*#__PURE__*/React.createElement("div", {
      className: classes.mobileColorsSelect
    }, colors.length > 1 ? /*#__PURE__*/React.createElement(Select, {
      value: selectedColors[0] || '',
      displayEmpty: true,
      fullWidth: true
    }, /*#__PURE__*/React.createElement(_MenuItem, {
      value: "",
      disabled: true
    }, "Select a color*"), colors.filter(color => !isReserve || color.availableQuantity > 0).map(color => {
      const {
        colorValue,
        colorName
      } = color;
      return /*#__PURE__*/React.createElement(_MenuItem, {
        value: colorValue,
        key: colorName,
        onClick: this.handleClick(color)
      }, /*#__PURE__*/React.createElement(Color, {
        color: colorValue,
        className: classes.colorBadge
      }), colorName);
    })) : /*#__PURE__*/React.createElement(ColorLabelWithTooltip, {
      hideTooltip: true,
      name: (_colors$ = colors[0]) === null || _colors$ === void 0 ? void 0 : _colors$.colorName,
      value: (_colors$2 = colors[0]) === null || _colors$2 === void 0 ? void 0 : _colors$2.colorValue,
      style: {
        borderColor: primaryColor
      }
    })));
  }
}